import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
// import { FrontPageData } from '../classes/front-page-site-data';
// import { FrontPageData } from '../classes/front-page-site-data';
// import { Globalvar } from '../classes/globalvar';

@Injectable()
export class FrontPageDataService {

  public banner = []
  public needs = []
  public megamenu = []

  constructor(private http: HttpClient) {
    // this.GetSiteData()
  }

  GetSiteData() {
    return this.http.get<any>("https://joytogive-api.worldvision.org.ph/api/public/get_site_data").toPromise()

    // .subscribe(
    //   (result) => {
    //     this.banner = result.banner
    //     this.needs = result.needs
    //     this.megamenu = result.megamenu
    //   },
    //   (err) => {
    //     console.log(err)
    //   }
    // )
    // return this.http.get<HomePageBanner[]>(Globalvar.ApiUrl +"/GetHomePageBanner?BannerId=")
  }

}
